import React from "react";
import "./LandingScreen.css";

const LandingScreen = () => {
  return (
    <div className="landing-container">
      <div className="section services">
        <h2>Our Services</h2>
        <p>
          REDrones provides drone photography and imaging services specifically
          tailored for real estate development projects. From initial ground
          clearing to final construction phases, our drones capture
          high-definition imagery and video data to help stakeholders monitor
          progress, assess project milestones, and make informed decisions.
        </p>
      </div>

      <div className="section info">
        <h2>Thank you for visiting REDrones</h2>
        <p>
          Please check back soon to explore new features and services designed
          to streamline the real estate development process.
        </p>
        <p>
          We value communication with our clients. Feel free to reach out at{" "}
          <a href="mailto:admin@redrones.com">admin@redrones.ie</a> to discuss
          how we can support your development goals.
        </p>
      </div>
    </div>
  );
};

export default LandingScreen;
